// Utility: escape special regex chars for safe replacement when using RegExp.
const _escapeForRegex = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

// Public function: convert legacy ShreeLipi encoded text in DOM <p> tags or provided string to Unicode.
function convertToUnicode(inputText) {
    const array_one = [
        'u', 'ª', '}', 'n', 'p',
        'H', '·', 'I', '»', 'J', '½', 'K',
        'M', 'À', 'N', 'µO', 'O', 'µÁ', 'Á', 'P',
        'Q', 'R', '¶S', 'S', '¶T', 'T', 'U', 'Ê',
        'W', 'Ï', 'V', 'Ë', 'Y', 'Ü', 'X', 'Z', 'Ý',
        '\\', 'â', '[', 'ß', '^', 'ä', ']', 'ã', '_', 'å',
        '`', 'a', 'c', 'ë', 'd', 'ì',
        'e', 'û', 'í', 'f', 'î', 'g', 'ñ', 'h', 'j', 'ú', 'k',
        'Ô', 'Û', 'Ú', 'à', 'Þ', 'Q­', 'º$', 'Ì', 'Ð', 'Õ', 'l', 'Îm', '¸', '„', 'ˆ', 'œ', 'Å',
        'Am¡', 'Am{', 'Am|', 'Am', 'A', 'B©', 'B', 'C', 'D', 'E{', 'E', 'F',
        'm°', 'm{', 'm|', '{', '|', 'm¡', 'm¢', '¡', '¢',
        'm', 'r', 's', 't', 'w', 'þ', 'y', '§', '±', '•', '¥', '²',
        'Ñ', '«', 'é', 'ê', '&', '$', '>', 'µ'
    ];

    const array_two = [
        '©', '©ं', '{©', 'o', 'o',
        'क', 'क्‌', 'ख', 'ख्‌', 'ग', 'ग्', 'घ',
        'च', 'च्‌', 'छ', 'ज़', 'ज', 'ज़्‌', 'ज्‌', 'झ',
        'ट', 'ठ', 'ड़', 'ड', 'ढ़', 'ढ', 'ण', 'ण्',
        'थ', 'थ्', 'त', 'त्', 'ध', 'ध्', 'द', 'न', 'न्',
        'फ', 'फ्‌', 'प', 'प्‌', 'भ', 'भ्', 'ब', 'ब्‌', 'म', 'म्',
        'य', 'र', 'ल', 'ल्‌', 'व', 'व्‌',
        'श', 'श्', 'श्', 'ष', 'ष्‌', 'स', 'स्', 'ह', 'क्ष', 'क्ष्', 'ज्ञ',
        'द्द', 'द्व', 'द्य', 'प्र', 'न्न', 'ट्र', 'क्त', 'त्र', 'द्र', 'द्ध', 'श्र', 'त्त', 'क्क', 'ल्ल', 'ह्व', 'श्व', 'ट्ट',
        'औ', 'ओ', 'ओं', 'आ', 'अ', 'ई', 'इ', 'उ', 'ऊ', 'ऐ', 'ए', 'ऋ',
        'ॉ', 'ो', 'ों', 'े', 'ें', 'ौ', 'ौं', 'ै', 'ैं',
        'ा', 'ी', 'ी', 'ीं', 'ु', 'ु', 'ू', 'ं', 'ँ', 'ः', 'ृ', '्‌',
        'दृ', '्र', 'रु', 'रू', '।', '', '', ''
    ];

    const array_one_length = array_one.length;

    // Acquire text
    let speechdata = inputText;
    if (typeof speechdata !== 'string') {
        speechdata = '';
        if (typeof document !== 'undefined') {
            const data = document.getElementsByTagName('p');
            for (let i = 0; i < data.length; i++) {
                speechdata += data[i].innerHTML + ' ';
            }
        }
    }

    let modified_substring = speechdata;

    const text_size = speechdata.length;
    let processed_text = '';
    let sthiti1 = 0;
    let sthiti2 = 0;
    let chale_chalo = 1;
    const max_text_size = 10000;

    while (chale_chalo === 1) {
        sthiti1 = sthiti2;
        if (sthiti2 < (text_size - max_text_size)) {
            sthiti2 += max_text_size;
            while (speechdata.charAt(sthiti2) !== ' ') {
                sthiti2--;
            }
        } else {
            sthiti2 = text_size;
            chale_chalo = 0;
        }
        modified_substring = speechdata.substring(sthiti1, sthiti2);
        Replace_Symbols();
        processed_text += modified_substring; // append
    }

    function Replace_Symbols() {
        if (modified_substring !== '') {
            for (let input_symbol_idx = 0; input_symbol_idx < array_one_length; input_symbol_idx++) {
                let indx = modified_substring.indexOf(array_one[input_symbol_idx]);
                while (indx !== -1) {
                    modified_substring = modified_substring.replace(array_one[input_symbol_idx], array_two[input_symbol_idx]);
                    indx = modified_substring.indexOf(array_one[input_symbol_idx]);
                }
            }

            // Handle positioning for chhotii 'i'
            let position_of_i = modified_substring.indexOf('o');
            while (position_of_i !== -1) {
                const charecter_next_to_i = modified_substring.charAt(position_of_i + 1);
                const charecter_to_be_replaced = 'o' + charecter_next_to_i;
                modified_substring = modified_substring.replace(charecter_to_be_replaced, charecter_next_to_i + 'ि');
                position_of_i = modified_substring.indexOf('o', position_of_i + 1);
            }

            // Remove incorrect ee on half letters
            let position_of_wrong_ee = modified_substring.indexOf('ि्');
            while (position_of_wrong_ee !== -1) {
                const consonent_next_to_wrong_ee = modified_substring.charAt(position_of_wrong_ee + 2);
                const charecter_to_be_replaced = 'ि्' + consonent_next_to_wrong_ee;
                modified_substring = modified_substring.replace(charecter_to_be_replaced, '्' + consonent_next_to_wrong_ee + 'ि');
                position_of_wrong_ee = modified_substring.indexOf('ि्', position_of_wrong_ee + 2);
            }

            // 'q' variant (anuswaar variant)
            position_of_i = modified_substring.indexOf('q');
            while (position_of_i !== -1) {
                const charecter_next_to_i = modified_substring.charAt(position_of_i + 1);
                const charecter_to_be_replaced = 'q' + charecter_next_to_i;
                modified_substring = modified_substring.replace(charecter_to_be_replaced, charecter_next_to_i + 'o');
                position_of_i = modified_substring.indexOf('q', position_of_i + 1);
            }

            // elimination after q adjustment
            position_of_wrong_ee = modified_substring.indexOf('o्');
            while (position_of_wrong_ee !== -1) {
                const consonent_next_to_wrong_ee = modified_substring.charAt(position_of_wrong_ee + 2);
                const charecter_to_be_replaced = 'o्' + consonent_next_to_wrong_ee;
                modified_substring = modified_substring.replace(charecter_to_be_replaced, '्' + consonent_next_to_wrong_ee + 'िं');
                position_of_wrong_ee = modified_substring.indexOf('o्', position_of_wrong_ee + 3);
            }

            // Replace remaining 'o'
            modified_substring = modified_substring.replace(/o/g, 'िं');

            // Reph handling
            const set_of_matras = 'ािीुूृेैोौंःँॅ';
            let position_of_reph = modified_substring.indexOf('©');
            while (position_of_reph > 0) {
                let probable_position_of_half_r = position_of_reph - 1;
                let charecter_at_probable_position_of_half_r = modified_substring.charAt(probable_position_of_half_r);
                while (set_of_matras.includes(charecter_at_probable_position_of_half_r)) {
                    probable_position_of_half_r -= 1;
                    charecter_at_probable_position_of_half_r = modified_substring.charAt(probable_position_of_half_r);
                }
                let charecter_to_be_replaced = modified_substring.substring(probable_position_of_half_r, position_of_reph);
                let new_replacement_string = 'र्' + charecter_to_be_replaced;
                charecter_to_be_replaced += '©';
                // Use regex escape for safety if needed multiple times
                const pattern = new RegExp(_escapeForRegex(charecter_to_be_replaced), 'g');
                modified_substring = modified_substring.replace(pattern, new_replacement_string);
                position_of_reph = modified_substring.indexOf('©');
            }
        }
    }
    return processed_text;
}


//---------------------------------------------------------------------------------------------

//---------------------------------------------------------------------------------------------------


function convertToShreeLipi(inputText) {
    // Acquire Unicode text
    let speechdata = inputText;
    if (typeof speechdata !== 'string') {
        speechdata = '';
        if (typeof document !== 'undefined') {
            const data = document.getElementsByTagName('p');
            for (let i = 0; i < data.length; i++) {
                speechdata += data[i].innerText + ' ';
            }
        }
    }

    const array_one = [
        'u', 'ª', '}', 'n', 'p', 'H', '·', 'I', '»', 'J', '½', 'K', 'M', 'À', 'N', 'µO', 'O', 'µÁ', 'Á', 'P', 'Q', 'R', '¶S', 'S', '¶T', 'T', 'U', 'Ê', 'W', 'Ï', 'V', 'Ë', 'Y', 'Ü', 'X', 'Z', 'Ý', '\\', 'â', '[', 'ß', '^', 'ä', ']', 'ã', '_', 'å', '`', 'a', 'c', 'ë', 'd', 'ì', 'e', 'û', 'í', 'f', 'î', 'g', 'ñ', 'h', 'j', 'ú', 'k', 'Ô', 'Û', 'Ú', 'à', 'Þ', 'Q­', 'º$', 'Ì', 'Ð', 'Õ', 'l', 'Îm', '¸', '„', 'ˆ', 'œ', 'Å', 'Am¡', 'Am{', 'Am|', 'Am', 'A', 'B©', 'B', 'C', 'D', 'E{', 'E', 'F', 'm°', 'm{', 'm|', '{', '|', 'm¡', 'm¢', '¡', '¢', 'm', 'r', 's', 't', 'w', 'þ', 'y', '§', '±', '•', '¥', '²', 'Ñ', '«', 'é', 'ê', '&'
    ];
    const array_two = [
        '©', '©ं', '{©', 'o', 'o', 'क', 'क्‌', 'ख', 'ख्‌', 'ग', 'ग्', 'घ', 'च', 'च्‌', 'छ', 'ज़', 'ज', 'ज़्‌', 'ज्‌', 'झ', 'ट', 'ठ', 'ड़', 'ड', 'ढ़', 'ढ', 'ण', 'ण्', 'थ', 'थ्', 'त', 'त्', 'ध', 'ध्', 'द', 'न', 'न्', 'फ', 'फ्‌', 'प', 'प्‌', 'भ', 'भ्', 'ब', 'ब्‌', 'म', 'म्', 'य', 'र', 'ल', 'ल्‌', 'व', 'व्‌', 'श', 'श्', 'श्', 'ष', 'ष्‌', 'स', 'स्', 'ह', 'क्ष', 'क्ष्', 'ज्ञ', 'द्द', 'द्व', 'द्य', 'प्र', 'न्न', 'ट्र', 'क्त', 'त्र', 'द्र', 'द्ध', 'श्र', 'त्त', 'क्क', 'ल्ल', 'ह्व', 'श्व', 'ट्ट', 'औ', 'ओ', 'ओं', 'आ', 'अ', 'ई', 'इ', 'उ', 'ऊ', 'ऐ', 'ए', 'ऋ', 'ॉ', 'ो', 'ों', 'े', 'ें', 'ौ', 'ौं', 'ै', 'ैं', 'ा', 'ी', 'ी', 'ीं', 'ु', 'ु', 'ू', 'ं', 'ँ', 'ः', 'ृ', '्‌', 'दृ', '्र', 'रु', 'रू', '।'
    ];
    const array_two_length = array_two.length;

    let modified_substring = speechdata;
    const text_size = speechdata.length;
    let processed_text = '';
    let sthiti1 = 0;
    let sthiti2 = 0;
    let chale_chalo = 1;
    const max_text_size = 10000;

    while (chale_chalo === 1) {
        sthiti1 = sthiti2;
        if (sthiti2 < (text_size - max_text_size)) {
            sthiti2 += max_text_size;
            while (speechdata.charAt(sthiti2) !== ' ') {
                sthiti2--;
            }
        } else {
            sthiti2 = text_size;
            chale_chalo = 0;
        }
        modified_substring = speechdata.substring(sthiti1, sthiti2);
        Replace_Symbols();
        processed_text += modified_substring;
    }

    function Replace_Symbols() {
        // Handle 'िं' (anuswaar variant) -> 'q'
        modified_substring = '  ' + modified_substring; // padding
        let position_of_f = modified_substring.indexOf('िं');
        while (position_of_f !== -1) {
            modified_substring = modified_substring.replace('िं', 'q');
            let character_left_to_f = modified_substring.charAt(position_of_f - 1);
            modified_substring = modified_substring.replace(character_left_to_f + 'q', 'q' + character_left_to_f);
            position_of_f -= 1;
            while (modified_substring.charAt(position_of_f - 1) === '्' && position_of_f !== 0) {
                const string_to_be_replaced = modified_substring.charAt(position_of_f - 2) + '्';
                modified_substring = modified_substring.replace(string_to_be_replaced + 'q', 'q' + string_to_be_replaced);
                position_of_f -= 2;
            }
            position_of_f = modified_substring.indexOf('िं', position_of_f + 1);
        }

        // Handle 'ि' -> position correction with 'o'
        position_of_f = modified_substring.indexOf('ि');
        while (position_of_f !== -1) {
            const character_left_to_f = modified_substring.charAt(position_of_f - 1);
            modified_substring = modified_substring.replace(character_left_to_f + 'ि', 'o' + character_left_to_f);
            position_of_f -= 1;
            while (modified_substring.charAt(position_of_f - 1) === '्' && position_of_f !== 0) {
                const string_to_be_replaced = modified_substring.charAt(position_of_f - 2) + '्';
                modified_substring = modified_substring.replace(string_to_be_replaced + 'o', 'o' + string_to_be_replaced);
                position_of_f -= 2;
            }
            position_of_f = modified_substring.indexOf('ि', position_of_f + 1);
        }

        // Reph handling: Replace 'र्<...>' with '<...>©'
        const set_of_matras = 'ािीुूृेैोौं:ँॅ';
        modified_substring += '  ';
        let position_of_half_R = modified_substring.indexOf('र्');
        let rephLoopGuard = 0;
        while (position_of_half_R > 0 && rephLoopGuard < 10000) { // safety guard
            rephLoopGuard++;
            let probable_position_of_Z;
            if (modified_substring.charAt(position_of_half_R + 3) !== '्') {
                probable_position_of_Z = position_of_half_R + 2; // next consonant start
            } else {
                probable_position_of_Z = position_of_half_R + 4; // skip halant + next consonant
            }
            let character_right_to_probable_position_of_Z = modified_substring.charAt(probable_position_of_Z + 1);
            while (set_of_matras.includes(character_right_to_probable_position_of_Z)) {
                probable_position_of_Z += 1;
                character_right_to_probable_position_of_Z = modified_substring.charAt(probable_position_of_Z + 1);
            }
            // Correct end index: include character at probable_position_of_Z
            const string_to_be_replaced = modified_substring.substring(position_of_half_R + 2, probable_position_of_Z + 1);
            const pattern = 'र्' + string_to_be_replaced;
            const replacement = string_to_be_replaced + '©';
            // Replace only first occurrence at this position to avoid unintended earlier matches
            if (modified_substring.indexOf(pattern, position_of_half_R) === position_of_half_R) {
                modified_substring = modified_substring.slice(0, position_of_half_R) + replacement + modified_substring.slice(position_of_half_R + pattern.length);
            } else {
                // If pattern mismatch, break to avoid infinite loop
                break;
            }
            position_of_half_R = modified_substring.indexOf('र्', position_of_half_R + replacement.length);
        }
        modified_substring = modified_substring.substring(0, modified_substring.length - 2);

        // Now substitute reverse mapping
        if (modified_substring !== '') {
            for (let input_symbol_idx = array_two_length - 1; input_symbol_idx > 0; input_symbol_idx--) {
                let indx = modified_substring.indexOf(array_two[input_symbol_idx]);
                while (indx !== -1) {
                    modified_substring = modified_substring.replace(array_two[input_symbol_idx], array_one[input_symbol_idx]);
                    indx = modified_substring.indexOf(array_two[input_symbol_idx]);
                }
            }
        }
    }
    return processed_text.trim();
}

// ESM exports only (React build uses ES Modules)
export { convertToUnicode, convertToShreeLipi };